export default Object.freeze({
    audio: 'AUDIO',
    images: 'IMAGES',
})